<template>
  <div class="modalAdd">
    <b-modal id="modalAddFiles" ref="modalAddFiles" centered size="lg" modal-class="modal-no-border modal-radius top-mb" @show="onOpen" no-close-on-backdrop>
      <template v-slot:modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100 ">
          <h2 class="title">ファイル追加</h2>
          <div class="btn-closeModal" @click="closeModalAdd">
            <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
          </div>
        </div>
      </template>
      <div class="modalUser--main" :class="{'chrome': checkChrome, 'firefox': checkFirefox }">
        <div class="form-group">
          <label for="name" class="vendor__label mt-15">ファイル名<span class="required">*</span></label>
          <div class="input-group">
            <input type="text" name="name" id="name" class="input-form input-custom-line" placeholder="ファイル名を入力してください" v-model="name" :class="formatName()">
            <small v-if="!$v.name.required && invalid" class="text-input error">{{message.FILE_NAME_REQUIRED}}</small>
            <small v-if="$v.name.required && invalid && !$v.name.valid" class="text-input error">{{message.FILE_NAME_FORMAT}}</small>
            <small v-if="errorName" class="text-input error">{{errorNameShow(errorName[0])}}</small>
          </div>
        </div>
        <div class="form-group">
          <label for="tags" class="vendor__label mt-15">タグ</label>
          <div>
            <div>
              <multiselect id="tags"
                           ref="multiselect"
                           class="tags-search"
                           @open="closeAutocomplete"
                           :value="tag" tag-placeholder="タグを入力してください"
                           placeholder="タグを入力してください" label="name"
                           :options="listTags" :hide-selected="true" @remove="closeTags"
                           :multiple="true" :taggable="true" track-by="name"
                           @select="onSelect"
                           selectLabel="選択するように押してください"
                           @search-change="getTag" @tag="addTag">
                <span slot="noOptions"></span>
                <span slot="noResult">タグが既に存在しています</span>
              </multiselect>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="vendor__label mt-15">説明</label>
          <div class="input-group">
            <textarea rows="4" placeholder="説明を入力してください" class="input-form textarea textarea-addFile" :class="{error: !$v.description.maxLength && invalid}" v-model="description"></textarea>
            <small v-if="!$v.description.maxLength && invalid" class="text-input error">{{message.FILE_NAME_REQUIRED}}</small>
          </div>
        </div>
        <div class="avatar-addFile">
          <div class="input-upload justify-content-between" v-if="popup">
            <div class="d-flex align-items-center avatar-upload-mb">
              <div class="avatar1 avatar-thumbnail upload-thumbnail">
                <img src="" alt class="avt-modal" ref="displayImage" v-if="showFile('image')"/>
                <img src="../../../assets/images/pdf.svg" alt class="avt-modal upload-thumb-pdf" ref="displayImage" v-if="showFile(  'pdf')"/>
                <video width="100%" controls src="" ref="displayVideo" id="video" v-if="showFile('video')" @canplaythrough="minuteVideo($event)" class="upload-video">
                </video>
                <div v-if="showProgressBar" class="w-100 progress-custom">
                  <b-progress :value="progressValue" :max="max" animated></b-progress>
                </div>
              </div>
              <div class="description">
                <div class="text-big d-none d-lg-block">{{namePicture}} - {{convertSize(size)}}</div>
                <div class="text-big d-block d-lg-none">{{namePicture}} - {{convertSize(size)}}</div>
              </div>
            </div>
            <div class="close-icon">
              <img src="@img/icon/icon-close.svg" @click="hideImage">
            </div>
          </div>
          <div class="input-upload justify-content-between" v-else>
            <div class="d-flex align-items-center avatar-upload-mb flex-wrap">
              <div class="avatar1 avatar-af">
                <div class="input-upload">
                  <label for="uploadfile3" class="label-upload"></label>
                  <input type="file" id="uploadfile3" name="uploadfile3" accept="image/*,video/*,video/mp4,video/m4v,video/mov,video/ogg,application/pdf,capture=camcorder" class="btn-file" @change="changeFile($event)"/>
                </div>
              </div>
              <div class="description">
                <div class="text-big">ファイル選択</div>
                <div class="text-small">画像は5MBまでPDFは２MBまで動画は300分まで。</div>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="fileError()">
            <div class="input-group">
              <small class="text-input error" v-if="!$v.file.required && invalid">{{message.FILE_REQUIRED}}</small>
              <small class="text-input error" v-if="formatFileError">{{message.FILE_FORMAT}}</small>
              <small class="text-input error" v-if="sizeFormatErrorVideo()">{{message.VIDEO_SIZE}}</small>
              <small class="text-input error" v-if="sizeFormatErrorImage()">{{message.IMAGE_SIZE}}</small>
              <small class="text-input error" v-if="sizeFormatErrorPdf()">{{message.PDF_SIZE}}</small>
            </div>
          </div>
          <div class="form-group" v-if="typeFile == 'video'">
            <label class="vendor__label mt-4">トリムビデオ</label>
            <vue-slider v-model="clip.value" :tooltip="'always'" :min="0" :max="clip.max" :dot-options="clip.dotOptions" :enable-cross="false" :tooltip-formatter="clip.tooltipFormat" @drag-start="createThumbnailForSlider($event)" @drag-end="createThumbnailForSlider($event)">
              <template v-slot:tooltip>
                <canvas id="canvas"></canvas>
                <div class="text-center">{{clip.tooltipFormat ? clip.tooltipFormat(): ''}}</div>
              </template>
            </vue-slider>
          </div>

          <!-- Start: Additional Attachments -->
          <div class="form-group" v-if="typeFile !== ''">
            <label class="vendor__label mt-4">添付ファイルを追加する</label>
            <div class="avatar-addFile" v-for="(file,index) in attachments" :key="`key-${file.refIndex}`">
              <div class="input-upload drag-handle justify-content-between" v-if="file.popup">
                <div class="d-flex align-items-center w-100">
                  <div class="avatar1 avatar-thumbnail upload-thumbnail">
                    <img :src="file.src" alt class="avt-modal" :id="`displayAttachment-${file.refIndex}`" :ref="`displayAttachment-${file.refIndex}`" v-if="file.type == 'image'"/>
                    <img src="../../../assets/images/pdf.svg" alt class="avt-modal upload-thumb-pdf" :ref="`displayAttachment-${file.refIndex}`" v-if="file.type == 'pdf'"/>
                  </div>
                  <div class="description" v-if="file.size > 0">
                    <div class="text-big d-none d-lg-block">{{file.videoName}} - {{convertSize(file.size)}}</div>
                    <div class="text-big d-lg-none d-block">{{file.videoName}} - {{convertSize(file.size)}}</div>
                  </div>
                </div>
                <div class="close-icon">
                  <img src="@img/icon/icon-close.svg" @click="changeAttachment(index)">
                </div>
              </div>
              <div class="input-upload drag-handle justify-content-between" v-else>
                <div class="d-flex align-items-center input-group avatar-upload-mb">
                  <div class="avatar1 avatar-af">
                    <div class="input-upload">
                      <label :for="`uploadfile2-${file.refIndex}`" class="label-upload"></label>
                      <input type="file" :id="`uploadfile2-${file.refIndex}`" :name="`uploadfile2-${file.refIndex}`" accept="image/*,application/pdf,capture=camcorder" class="btn-file"  @change="changeAttachmentFile($event, index)"/>
                    </div>
                  </div>
                  <div class="description">
                    <div class="text-big">ファイル選択</div>
                    <div class="text-small">最大5MBの画像PDF最大2MB。</div>
                  </div>
                </div>
                <div class="close-icon">
                  <img src="@img/icon/icon-close.svg" @click="removeAttachment(index)">
                </div>
              </div>
              <div class="form-group drag-handle" >
                <div class="input-group">
                  <small class="text-input error" v-if="hasError('format', file)">{{message.FILE_FORMAT}}</small>
                  <small class="text-input error" v-if="hasError('size', file)">{{message.VIDEO_SIZE}}</small>
                  <small class="text-input error" v-if="hasError('empty', file)">{{message.FILE_REQUIRED}}</small>
                </div>
              </div>
            </div>

            <b-button @click="addAttachments" class="mt-3">
              追加
            </b-button>
          </div>
          <!-- End: Additional Attachments -->

        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <div class="d-flex justify-content-center btn-reverse">
            <b-button
              variant="secondary"
              :disabled="buttonLoad"
              class="btn btn-rounder btn-contact w-100 btn-basic mr-30"
              type="button" @click="closeModalAdd">キャンセル</b-button>
            <b-button
              variant="primary"
              :disabled="buttonLoad"
              class="btn btn-rounder btn-contact w-100 btn-basic"
              type="button" @click="addFile">
                追加
                <span v-if="buttonLoad">
                  <b-spinner small></b-spinner>
                </span>
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal, BProgressBar } from 'bootstrap-vue'
import {maxLength, required} from 'vuelidate/lib/validators'
import {MESSAGE} from '@/utils/errorjapanese'
import {mapState} from 'vuex'
import Multiselect from 'vue-multiselect'
import errorMessage from '../../../utils/errormessage'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import _ from 'lodash'
export default {
  name: 'AddFile',
  data () {
    return {
      modalShow: false,
      name: '',
      file: '',
      typeFile: '',
      description: '',
      tag: [],
      tags: [],
      videoError: false,
      namePicture: '',
      size: '',
      minute: 0,
      popup: false,
      invalid: false,
      message: MESSAGE,
      max: 100,
      formatFileError: false,
      checkChrome: false,
      checkFirefox: false,
      clip: {
        value: 0,
        dotOptions: {
          tooltip: 'hover'
        }
      },
      buttonLoad: false,
      attachments: [],
      chunkSize: (1024 * 1024) * 10 // 10mb
    }
  },
  validations: {
    name: {
      required,
      valid (name) {
        return !name.includes('/')
      }
    },
    file: {
      required,
      validSize (file) {
        if (file) {
          if (file.name.match(/\.(jpg|jpeg|png|bmp|gif)$/i)) {
            return file.size <= 5242880
          }
          if (file.name.match(/\.(pdf)$/i)) {
            return file.size <= 2097152
          }
          // Commented to disable file limit for video file upload
          // if (file.name.match(/\.(webm|mkv|flv|vob|avi|wmv|mp4|mov|m4v)$/i)) {
          //   return file.size <= 52428800
          // }
        }
        return true
      }
    },
    description: {
      maxLength: maxLength(1000)
    }
  },
  components: {
    'b-modal': BModal,
    'b-progress-bar': BProgressBar,
    'multiselect': Multiselect,
    VueSlider
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  watch: {
    'file' () {
      this.videoError = false
    },
    'minute' (value) {
      if (value > 300) {
        this.videoError = true
      }
    },
    'name' () {
      this.$store.commit('adminFolder/CHANGE_ERROR_NAME', '')
    }
  },
  methods: {
    back () {
      this.$emit('pageIndexBack')
    },
    onOpen () {
      this.typeFile = ''
      this.showFile('')
    },
    formatName () {
      return ((!this.$v.name.required || !this.$v.name.valid) && this.invalid) || this.errorName ? 'error' : ''
    },
    inputNameError () {
      return (!this.$v.name.required && this.invalid) || this.errorName ? 'error' : ''
    },
    fileError () {
      return ((!this.$v.file.required || !this.$v.file.validSize || this.videoError) && this.invalid) || this.formatFileError
    },
    errorNameShow (value) {
      return errorMessage.errorFile(value)
    },
    sizeFormatErrorVideo () {
      return ((!this.$v.file.validSize && this.typeFile === 'video') || this.videoError) && this.invalid && this.$v.file.required
    },
    sizeFormatErrorImage () {
      return !this.$v.file.validSize && (this.typeFile === 'image') && this.invalid && this.$v.file.required
    },
    sizeFormatErrorPdf () {
      return !this.$v.file.validSize && (this.typeFile === 'pdf') && this.invalid && this.$v.file.required
    },
    minuteVideo (e) {
      this.clip.value = [0, parseInt(e.target.duration)]
      this.clip.max = parseInt(e.target.duration)
      // this.clip.tooltipFormat = value => this.secondsToHHMMSS(value).readableFormat
      this.minute = e.target.duration / 60 // convert second to minute
      this.createThumbnailForSlider()
      console.log('Clip', this.clip)
    },
    closeAutocomplete () {
      this.$refs.multiselect.$refs.search.setAttribute('autocomplete', 'off')
    },
    closeTags (index) {
      let deleteIndex = this.tag.findIndex(n => n.name === index.name)
      this.tag.splice(deleteIndex, 1)
    },
    onSelect (skill) {
      let data = null
      if (!_.isEmpty(this.tag)) {
        data = this.tag.find(n => n.name === skill)
      }
      if (_.isEmpty(this.tag) || (!_.isEmpty(this.tag) && !data)) {
        this.tag.push(skill)
      }
    },
    addTag (skill) {
      let data = null
      const tag = {
        name: skill
      }
      if (!_.isEmpty(this.tag)) {
        data = this.tag.find(n => n.name === skill)
      }
      if (_.isEmpty(this.tag) || (!_.isEmpty(this.tag) && !data)) {
        this.tag.push(tag)
      }
    },
    getTag (value) {
      if (value) {
        setTimeout(() => {
          this.$store.dispatch('adminFolder/getTag', {name: value, company_id: this.$route.params.id})
        }, 1000)
      } else {
        setTimeout(() => {
          this.$store.dispatch('adminFolder/getTag', {company_id: this.$route.params.id})
        }, 1000)
      }
    },
    showModalAddFiles () {
      this.$root.$emit('bv::show::modal', 'modalAddFiles', '#modalAddFiles')
    },
    changeFile (e) {
      e.preventDefault()
      this.formatFileError = false
      this.file = e.target.files[0]
      const file = e.target.files[0]
      this.namePicture = e.target.files[0].name
      this.size = e.target.files[0].size
      if (file.name.match(/\.(webm|mkv|flv|vob|avi|wmv|mp4|mov|m4v)$/i)) {
        this.popup = true
        this.typeFile = 'video'
        if (this.popup) {
          setTimeout(() => {
            this.$refs.displayVideo.src = URL.createObjectURL(this.file)
          }, 50)
        }
      } else if (file.name.match(/\.(jpg|jpeg|png|bmp|gif)$/i)) {
        this.popup = true
        this.typeFile = 'image'
        let reader = new FileReader()
        reader.addEventListener('load', function () {
          this.$refs.displayImage.src = reader.result
        }.bind(this), false)
        reader.readAsDataURL(this.file)
      } else if (file.name.match(/\.(pdf)$/i)) {
        this.popup = true
        this.typeFile = 'pdf'
      } else {
        this.popup = false
        this.formatFileError = true
        this.typeFile = ''
      }
    },
    showFile (value) {
      return value === this.typeFile
    },
    async addFile (e) {
      e.preventDefault()
      if (this.minute > 300) {
        this.invalid = true
        this.videoError = true
        return
      }
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      this.buttonLoad = true
      const formData = new FormData()
      if (this.description) {
        formData.append('description', this.description)
      }
      formData.append('name', this.name)
      for (let i = 0; i < this.tag.length; i++) {
        if (this.tag[i].id) {
          this.tags.push({id: this.tag[i].id, name: this.tag[i].name})
        } else {
          this.tags.push({name: this.tag[i].name})
        }
      }
      if (this.showFile('video')) {
        formData.append('clipStart', this.clip.value[0])
        formData.append('clipEnd', this.clip.value[1])
        formData.append('duration', this.minute)
      }
      formData.append('file', this.file)
      if (this.tags) {
        for (let i = 0; i < this.tags.length; i++) {
          if (this.tags[i].id) {
            formData.append('tags' + '[' + i + ']' + '[name]', this.tags[i].name)
            formData.append('tags' + '[' + i + ']' + '[id]', this.tags[i].id)
          } else {
            formData.append('tags' + '[' + i + ']' + '[name]', this.tags[i].name)
          }
        }
      }

      formData.append('totalAttachments', this.attachments.length)
      if (this.attachments.length > 0) {
        for (var i in this.attachments) {
          formData.append(`attachments${i}`, this.attachments[i].file)
          formData.append(`attachments${i}-type`, this.attachments[i].type)
        }
      }

      formData.append('folder_parent_id', this.$route.params.folder_id)
      formData.append('company_id', this.$route.params.id)
      if (this.file.size > 0/** this.chunkSize */) {
        // Chunk upload
        let chunks = this.createChunks(this.file, this.chunkSize)
        this.uploadChunk(chunks, formData, 0, this.file.name)
      } else {
        formData.append('file', this.file)
        formData.append('is_chunked', 0)
        await this.$store.dispatch('adminFolder/addFile', {formData: formData,
          callback: () => {},
          back: this.back,
          modal: this.hideModal,
          folder_parent_id: this.$route.params.folder_id,
          company_id: this.$route.params.id,
          clear: this.clearData})
        this.buttonLoad = false
      }
    },
    async checkUpload (id) {
      await this.$store.dispatch('adminFolder/checkUpload', {
        id: id,
        back: this.back,
        modal: this.hideModal,
        folder_parent_id: this.$route.params.folder_id,
        company_id: this.$route.params.id,
        clear: this.clearData,
        callback: (data) => {
          if (data.status === 400 || data.status === 500) {
            this.$toastr.e('エラーが発生しました。 もう一度やり直してください。')
            this.buttonLoad = false
            return
          }
          if (data.status === 201) {
            this.buttonLoad = false
            return
          }
          setTimeout(async () => {
            await this.checkUpload(id)
          }, 10000)
        }
      })
    },
    async uploadChunk (chunks, data, chunkNum, filename) {
      data.set('file', chunks[chunkNum], filename)
      await this.$store.dispatch('adminFolder/uploadChunk', {
        formData: data,
        callback: async (filename) => {
          chunkNum = chunkNum + 1
          if (chunkNum < chunks.length) {
            data.append('file_temp_name', filename)
            this.uploadChunk(chunks, data, chunkNum, filename)
          } else {
            data.append('file_temp_name', filename)
            data.append('is_chunked', 1)
            data.delete('file')
            await this.$store.dispatch('adminFolder/addFile', {formData: data,
              back: this.pageIndexBack,
              modal: this.hideModal,
              folder_parent_id: this.$route.params.folder_id,
              company_id: this.$route.params.id,
              clear: this.clearData,
              callback: (resp) => {
                this.checkUpload(resp.data.id)
              }})
          }
        }
      })
    },
    createChunks (file, cSize) {
      let startPointer = 0
      let endPointer = file.size
      let chunks = []
      while (startPointer < endPointer) {
        let newStartPointer = startPointer + cSize
        chunks.push(file.slice(startPointer, newStartPointer))
        startPointer = newStartPointer
      }
      return chunks
    },
    clearData () {
      this.file = ''
      this.tag = []
      this.tags = []
      this.description = ''
      this.name = ''
      this.popup = false
      this.namePicture = ''
      this.size = ''
    },
    hideModal () {
      this.$root.$emit('bv::hide::modal', 'modalAddFiles', '#modalAddFiles')
    },
    hideImage () {
      this.videoError = false
      this.popup = false
      this.file = ''
      this.videoError = ''
      this.minute = 0
      this.typeFile = ''
    },
    closeModalAdd () {
      this.minute = 0
      this.videoError = ''
      this.typeFile = ''
      this.file = ''
      this.tag = []
      this.tags = []
      this.description = ''
      this.name = ''
      this.popup = false
      this.namePicture = ''
      this.size = ''
      this.invalid = false
      this.$root.$emit('bv::hide::modal', 'modalAddFiles', '#modalAddFiles')
    },
    remove (index) {
      this.tag.splice(index, 1)
    },
    changeAttachment (index) {
      this.attachments[index].popup = false
    },
    changeAttachmentFile (e, index) {
      e.preventDefault()
      const file = e.target.files[0]
      this.attachments[index].file = e.target.files[0]
      this.attachments[index].videoName = e.target.files[0].name
      this.attachments[index].size = e.target.files[0].size

      this.attachments[index].errors = {}

      if (file.name.match(/\.(jpg|jpeg|png|bmp|gif)$/i)) {
        if (this.attachments[index].size >= 5242880) {
          this.attachments[index].popup = false
          this.attachments[index].errors.size = true
          this.$forceUpdate()
          return false
        }

        let reader = new FileReader()
        this.attachments[index].popup = true
        this.attachments[index].type = 'image'

        reader.onload = e => {
          this.attachments[index].src = e.target.result
        }
        reader.readAsDataURL(file)
      } else if (file.name.match(/\.(pdf)$/i)) {
        if (this.attachments[index].size >= 2097152) {
          this.attachments[index].popup = false
          this.attachments[index].errors.size = true
          this.$forceUpdate()
          return false
        }
        this.attachments[index].popup = true
        this.attachments[index].type = 'pdf'
      } else {
        this.attachments[index].popup = false
        this.attachments[index].errors.format = true; return false
      }
    },
    addAttachments () {
      this.attachments.push(
        {
          file: null,
          videoName: '',
          duration: 0,
          size: 0,
          rangeValue: [0],
          min: 0,
          max: 100,
          errors: {},
          popup: false,
          refIndex: (Date.now() + Math.random()),
          type: '',
          src: ''
        }
      )
    },
    removeAttachment (index) {
      this.attachments.splice(index, 1)
    },
    hasError (type, file) {
      if (Object.keys(file.errors).length > 0) {
        let keys = Object.keys(file.errors)
        if (type === 'empty') {
        }
        return keys.includes(type)
      }
      return false
    },
    createThumbnailForSlider (index = 0) {
      const file = this.file
      var canvas = document.getElementById('canvas')
      var video = document.createElement('video')
      // this is important
      video.autoplay = true
      video.muted = true
      video.src = URL.createObjectURL(file)
      video.currentTime = this.clip.value[index]
      this.file.rangeValue = [...this.clip.value]
      // this.clip.value
      video.addEventListener('seeked', () => {
        canvas.width = 100
        canvas.height = 100

        this.clip.tooltipFormat = value => this.secondsToHHMMSS(this.clip.value[index]).readableFormat

        let ctx = canvas.getContext('2d')
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

        canvas.toDataURL('image/jpeg')
      })
    }
  },
  computed: {
    ...mapState({
      progressValue: state => state.adminFolder.progressValue,
      listTags: state => state.adminFolder.listTags,
      errorName: state => state.adminFolder.errorName,
      showProgressBar: state => state.adminFolder.showProgressBar
    })
  },
  mounted () {
    var device = navigator.userAgent.toLowerCase()

    // add class for chrome in macos
    if (device.indexOf('chrome') > -1) {
      this.checkChrome = true
    }
    // add class for firefox in macos
    if (device.indexOf('firefox') > -1) {
      this.checkFirefox = true
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/vendor/detail_vendor.scss";
@import "@/assets/stylesheet/vendor/uploadfile.scss";
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
.text-input.error {
  color: #de0000;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/Admin/FolderManagerment/AddFile.vue